// extracted by mini-css-extract-plugin
export default {"strong":"strong__MDNhZ","serif":"serif__MWE4O"};